import React, { useEffect, useRef, useState } from "react";

export const TableBody = (props) => {
	const {
		projects,
		TrMove,
		TrMouseEnter,
		TrMouseLeave,
		TrMouseClick,
		TrRef,
		Visible,
	} = props;

	const [hoverStates, setHoverStates] = useState(projects.map(() => false));
	const trRefs = useRef(projects.map(() => React.createRef()));

	useEffect(() => {
		TrRef(trRefs.current.map((ref) => ref.current));
	}, []);

	return (
		<tbody>
			{projects.map((project, key) => {

				return (
					<tr
						className={`${hoverStates[key] && Visible ? "up" : ""} ${
							project.archive ? "archive" : ""
						}`}
						ref={trRefs.current[key]}
						key={key}
						onMouseMove={(e) => TrMove({ project, e })}
						onMouseEnter={(e) => {
							TrMouseEnter({ project, e });
							setHoverStates((prevHoverStates) => {
								const updatedStates = [...prevHoverStates];
								updatedStates[key] = true;
								return updatedStates;
							});
						}}
						onMouseLeave={(e) => {
							TrMouseLeave({ project, e });
							setHoverStates((prevHoverStates) => {
								const updatedStates = [...prevHoverStates];
								updatedStates[key] = false;
								return updatedStates;
							});
						}}
						onClick={(e) => TrMouseClick({ project, e })}
					>
						<td>{project.name.name}</td>
						<td>{project.ville.name}</td>
						<td>{project.categories.name}</td>
						<td>{project.date.name}</td>
					</tr>
				);
			})}
		</tbody>
	);
};
